export default "<div class=\"app\">\r\n    <div class=\"row\">\r\n    </div>\r\n</div>";